// extracted by mini-css-extract-plugin
export default {"root":"c1V87","header":"YdO0B","title":"v_Cdo","giftsList":"q2dp8","backButton":"XKIDv"};